/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 16:22:59 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
import React, { Fragment } from 'react';
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { Link, Typography } from '@material-ui/core';
import {
  AssignmentOutlined,
  BusinessOutlined,
  CancelOutlined,
  CheckCircleOutline,
  PeopleOutline,
} from '@material-ui/icons';
import { formatMoneyPlan } from 'utils';
import { subscriptionPeriodEnum, planTypeOptions } from 'utils/choices';

const ConfirmModalContent = ({ classes, data, isFreeTrialUsed, translate }) => {
  const { newSubscription, planType } = data || {};

  const isFreePlan = planType === subscriptionPeriodEnum.freePlan;

  const planTypeKey =  planTypeOptions[planType];

  if (data && newSubscription) {
    const includedList = newSubscription.capabilities.map(
      permission =>
        permission.enabled && (
          <ListItem key={`${permission.id}Item`}>
            <ListItemIcon>
              <CheckCircleOutline color="primary" />
            </ListItemIcon>
            <ListItemText primary={permission.description} />
          </ListItem>
        )
    );
    const notIncludedList = newSubscription.capabilities
      .filter(permission => !permission.enabled)
      .map(permission => (
        <ListItem textDecoration="line-through" key={`${permission.id}Item`}>
          <ListItemIcon>
            <CancelOutlined color="error" />
          </ListItemIcon>
          <ListItemText primary={permission.description} />
        </ListItem>
      ));
    includedList.push(
      <ListItem key="maxEmployeeItem">
        <ListItemIcon>
          <PeopleOutline color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={translate(
            'resources.SubscriptionTier.fields.upToMaxEmployee',
            { maxNo: newSubscription.maximumEmployees }
          )}
        />
      </ListItem>
    );
    includedList.push(
      <ListItem key="maxSubcontractorItem">
        <ListItemIcon>
          <BusinessOutlined color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={translate(
            'resources.SubscriptionTier.fields.upToMaxSubcontractor',
            { maxNo: newSubscription.maximumSubcontractors }
          )}
        />
      </ListItem>
    );
    includedList.push(
      <ListItem key="maxProjectItem">
        <ListItemIcon>
          <AssignmentOutlined color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={translate(
            'resources.SubscriptionTier.fields.upToMaxProject',
            { maxNo: newSubscription.maximumProjects }
          )}
        />
      </ListItem>
    );
    return (
      <Fragment>
        <Typography color="primary" variant="h4">
          {newSubscription.name}
        </Typography>
        <Typography color="primary" variant="h6">
          {`${
            planType === subscriptionPeriodEnum.monthlyPlan
              ? translate(
                  'resources.SubscriptionTier.fields.monthlySubscription'
                )
              : planType === subscriptionPeriodEnum.annualPlan ?
                translate(
                  'resources.SubscriptionTier.fields.annualSubscription'
                )
                :
                translate(
                  'resources.SubscriptionTier.fields.freeSubscription'
                )

          }`}
        </Typography>
        <Typography
          variant="subtitle1"
          className={classes.confirmModalSubtitle1}
        >
          {translate(
            'resources.SubscriptionTier.fields.confirmationModalSubtitleInc'
          )}
        </Typography>
        <List dense={true}>{includedList}</List>
        {notIncludedList && notIncludedList.length > 0 && (
          <Typography
            variant="subtitle1"
            className={classes.confirmModalSubtitle2}
          >
            {translate(
              'resources.SubscriptionTier.fields.confirmationModalSubtitleNotInc'
            )}
          </Typography>
        )}
        <List dense={true}>{notIncludedList}</List>
        <Divider />
        <Typography
          variant="subtitle2"
          className={classes.confirmModalSubtitle1}
        >
         {!isFreePlan && translate('resources.SubscriptionTier.fields.confirmationContent1')}
         {isFreePlan && translate('resources.SubscriptionTier.fields.confirmationContent1Free')}
          <Link href="https://pasma.co.uk" target="_blank">
            {translate('resources.SubscriptionTier.fields.terms')}
          </Link>
          {
            isFreePlan 
            ? translate('resources.SubscriptionTier.fields.confirmationContent2Free')
            :
            newSubscription.freeTrialDuration && !isFreeTrialUsed && !isFreePlan
            ? translate(
                'resources.SubscriptionTier.fields.confirmationContent2',
                { freeTrialLength: newSubscription.freeTrialDuration }
              )
            : translate(
                'resources.SubscriptionTier.fields.confirmationContent2NoFreeTrial'
              )}
          {!isFreePlan && (
            <>
            <span className={classes.confirmationText}>
              {` ${formatMoneyPlan(newSubscription[planTypeKey].cost)}`}
            </span>
            {<span className={classes.confirmationText}>{`${
              planType === subscriptionPeriodEnum.monthlyPlan
                ? translate('resources.SubscriptionTier.fields.perMonth')
                : translate('resources.SubscriptionTier.fields.perYear')
            }`}</span>}
            </>
          )}
        </Typography>
      </Fragment>
    );
  }
  return null;
};

export default ConfirmModalContent;
